import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import FullLogo from '../assets/logos/full-logo.png'
import CirclesBg from '../assets/svgs/not-found-circles.svg?url'
import ErrorIcon from '../assets/svgs/ErrorIcon'
import { ReactComponent as RefreshIcon } from '../assets/svgs/refresh-cw.svg'
import { CoreButton } from './buttons/CoreButton'

import {
  PageWrapper,
  BgCircles,
  ContentArea,
  SearchCircle,
  PageTitle,
  PageDescription,
} from '../features/interviews/components/styled'
import { FooterContent } from '../features/interviews/components/styled'
import theme from '../constants/theme'
import { ErrorBoundaryErrorMessageBox, ErrorBoundaryErrorMessageText } from './styled'

class ErrorBoundary extends Component {
  state = {
    hasError: false,
    error: null,
  }

  static getDerivedStateFromProps(props, state) {
    if (props.routerError && !state.hasError) {
      return { hasError: true, error: props.routerError }
    }
    return null
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidMount() {
    if (this.props.routerError) {
      console.error('Router error boundary caught:', this.props.routerError)
    }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary caught:', error, errorInfo)
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
    window.location.reload()
  }

  handleLogin = () => {
    window.location.href = '/login'
  }

  render() {
    const { t } = this.props

    if (this.state.hasError) {
      return (
        <PageWrapper>
          <div className="p-3 ps-4">
            <img height="auto" width="130" src={FullLogo} alt="Talentino" />
          </div>

          <BgCircles>
            <img src={CirclesBg} alt="" aria-hidden="true" className="w-100" />
          </BgCircles>

          <ContentArea>
            <SearchCircle
              style={{
                marginBottom: '1.5rem',
                borderColor: `${theme.danger}30`,
              }}
            >
              <ErrorIcon />
            </SearchCircle>

            <PageTitle>{t('errorBoundary.heading')}</PageTitle>

            <PageDescription style={{ marginBottom: '2rem' }}>
              {t('errorBoundary.message')}
            </PageDescription>

            <ErrorBoundaryErrorMessageBox style={{ marginBottom: '2rem' }}>
              <ErrorBoundaryErrorMessageText>
                {this.state.error?.message ||
                  String(this.state.error) ||
                  t('errorBoundary.defaultError')}
              </ErrorBoundaryErrorMessageText>
            </ErrorBoundaryErrorMessageBox>
          

            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center align-items-center">
              <CoreButton
                variant="solid-primary"
                size="md"
                onClick={this.handleReset}
              >
                <RefreshIcon width={18} height={18} />
                {t('errorBoundary.retryButton')}
              </CoreButton>

              <CoreButton
                variant="outlined-neutral"
                size="md"
                onClick={this.handleLogin}
              >
                {t('errorBoundary.goToLogin')}
              </CoreButton>
            </div>
          </ContentArea>

          <FooterContent className="fixed-bottom text-center py-2 border-top border-gray-200">
            {t('footer.TalentinoAI')} © {new Date().getFullYear()}{' '}
            {t('footer.allRightsReserved')}
          </FooterContent>
        </PageWrapper>
      )
    }

    return this.props.children
  }
}

export default withTranslation()(ErrorBoundary)
